import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import {
  createStyles,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
} from '@material-ui/core';

import { Link, useHistory } from 'react-router-dom';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../theme';

import StandardInputComponent from '../form-elements/standard-input';
import PasswordInputComponent from '../form-elements/password-input';
import { ROUTE_PATHS } from '../../contants/ROUTE_PATHS';
import SubmitButton from '../form-elements/submit-button';

import { authLoaded, authLoading, setAppLoadingState } from '../../store';
import { signInUserViaEmailPassword } from '../../services';
import HeaderNavItem from '../navigation-components/header-nav-item';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logInFormContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
    logo: {
      width: '150px',
    },
    center: {
      textAlign: 'center',
    },
    inputBase: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      borderRadius: '5px',
      width: '100%',
    },
    forgotLink: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
    submitButton: {
      fontSize: '1em',
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    errorMessage: {
      color: theme.palette.error.main,
    },
  }),
);

export default function LogInForm(props: any) {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);
  const defaultFormValues = {
    email: '',
    password: '',
  };
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [errorMessage, setErrorMessage] = useState('');
  const [isOpen, setOpen] = useState(false);
  const history = useHistory();

  const handleClose = (event: any) => {
    event.preventDefault();
    setOpen(false);
  };

  const handleNavigateAndClose = (event: any) => {
    setOpen(false);
  };

  const handleOpen = (event: any) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleChange = (prop: any) => (event: any) => {
    setFormValues({ ...formValues, [prop]: event.target.value });
  };

  const handleSubmit = async () => {
    dispatch(authLoading());
    try {
      setAppLoadingState(dispatch, true);
      await signInUserViaEmailPassword(formValues);
      setFormValues(defaultFormValues);
      if (!(history.location && history.location.pathname && history.location.pathname.startsWith('/shared'))) {
        history.push('/admin');
      }
      setAppLoadingState(dispatch, false);
    } catch (error) {
      console.log(error);
      setAppLoadingState(dispatch, false);
      setErrorMessage('Sorry, there is a problem with your Username or Password');
      dispatch(authLoaded());
    }
  };

  return (
    <Grid item container direction="column" xs={12}>
      <Grid item container xs={12}>
        <Grid item container xs={10}/>
        <Grid item container xs={2}>
          <HeaderNavItem title="Log in" onClick={handleOpen} />
        </Grid>
      </Grid>

      <Dialog
        open={isOpen}
        onClose={handleClose}
        maxWidth="xs"
      >
        <DialogTitle className={classes.center}>
          <img
            src="/images/Reliht_logo.svg"
            alt="Reliht: Equpping Leaders for the Kingdom of God"
            className={classes.logo} />
        </DialogTitle>
        <DialogContentText>
          <Grid item container xs={12} className={classes.logInFormContainer}>
            <Grid item xs={12}>
              <FormControl variant="filled" className={classes.inputBase}>
                <StandardInputComponent
                  id="email"
                  label="Email"
                  value={formValues.email}
                  onChange={handleChange('email')}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="filled" className={classes.inputBase}>
                <PasswordInputComponent
                  id="password"
                  label="Password"
                  value={formValues.password}
                  onChange={handleChange('password')}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Link
                to={ROUTE_PATHS.USER_HELP}
                className={classes.forgotLink}
                onClick={handleNavigateAndClose}>
                Forgot Password?
              </Link>
            </Grid>
          </Grid>
          <Grid item className={`${classes.errorMessage} ${classes.logInFormContainer}`}>
            {errorMessage}
          </Grid>
        </DialogContentText>
        <DialogActions>
          <SubmitButton
            className={classes.submitButton}
            onClick={handleSubmit}
            text="Log In"
            variant="dark"
            loading={auth.loading}
          />
        </DialogActions>
      </Dialog>

    </ Grid>
  );
}
